var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: ['cms', _vm._isMobile() ? 'mobile' : '']
  }, [_c('div', {
    staticClass: "cms-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.courseInfo.courseName))]), _c('div', {
    staticClass: "cms-info"
  }, [_c('span', {
    staticClass: "gap"
  }, [_vm._v("浏览次数：" + _vm._s(_vm.courseInfo.viewNum) + "次 | " + _vm._s(_vm.courseInfo.courseDesc))])]), _c('a-breadcrumb', [_c('a-breadcrumb-item', [_c('a', {
    attrs: {
      "href": "/courseHome"
    }
  }, [_vm._v("课程首页")])]), _c('a-breadcrumb-item', [_c('a', {
    attrs: {
      "href": "/course/list"
    }
  }, [_vm._v("课程列表")])]), _c('a-breadcrumb-item', [_vm._v(_vm._s(_vm.courseInfo.courseName))])], 1)], 1), _c('a-divider'), _c('div', {
    staticClass: "course-content"
  }, [_c('a-row', {
    attrs: {
      "type": "flex",
      "gutter": 12
    }
  }, [_c('a-col', {
    staticClass: "course-video",
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 16,
      "lg": 16,
      "xl": 16
    }
  }, [_c('video', {
    ref: "videoPlayer",
    staticClass: "video-js vjs-fluid vjs-default-skin vjs-big-play-centered"
  }), _c('br'), _c('p', {
    staticClass: "gap"
  }, [_vm._v("浏览次数：" + _vm._s(_vm.courseInfo.viewNum) + "次 | " + _vm._s(_vm.courseInfo.courseDesc))]), _vm.currentMedia.desc ? _c('div', [_c('a-divider', [_vm._v("视频信息")]), _c('pre', [_vm._v(_vm._s(_vm.currentMedia.desc))])], 1) : _vm._e()]), _c('a-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 8,
      "lg": 8,
      "xl": 8
    }
  }, [_vm.treeData.length > 0 ? _c('a-tree', {
    attrs: {
      "defaultExpandAll": true,
      "selectedKeys": [_vm.currentMedia.key],
      "tree-data": _vm.treeData
    },
    on: {
      "select": _vm.onSelect
    }
  }) : _vm._e()], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };